<template>
  <v-slide-y-transition mode="out-in">
    <v-container v-if="currentMenu != null" fluid fill-height scrollable>
      <v-card flat>
        <v-card-title class="headline">{{ title }}
          <v-switch
            primary
            label="Attivo"
            v-model="currentMenu.isActive"
            style="justify-content: flex-end;"        
          ></v-switch>
        </v-card-title>
        <v-card-text>
          <DescrEditor v-model="currentMenu.descrizione" :currentLang="currentLang" @changeLang="changeLang" @setDescr="setDescr" />
          <v-select :items="listini" v-model="currentMenu.listino" label="Listino default" item-text="descrizione" item-value="_id"></v-select>
          <v-switch
            v-if="classModeEnabled"
            primary
            label="Abilita Modo Classe (comanda unica, scontrini separati)"
            v-model="currentMenu.itsClassMenu"
            @change="checkTakeAwayValue"
          ></v-switch>
          <v-switch primary label="Il menu può essere scelto per lo SFOGLIAMENU" v-model="currentMenu.isBrowseable"></v-switch>
          <v-switch primary label="Da asporto" v-model="currentMenu.isTakeAway" @change="checkClassValue"> </v-switch>
          <v-layout column v-if="currentUser.creditCardPaymentActive" class="mb-4">
            <h3 class="headline mb-3">
              Pagamento con carta di credito
            </h3>
            <v-card class="mb-3 elevation-4 grey darken-4">
              <v-card-text>
                <v-text-field
                  class="mb-2 mr-3"
                  v-model="currentMenu.deliveryPriceModifiers.minimumCreditCardPayableOrder"
                  prepend-icon="euro_symbol"
                  label="Importo minimo per rendere pagabile l'ordine con carta di credito"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-layout>
          <v-layout column v-if="currentMenu.isTakeAway" class="mb-4">
            <h3 class="headline mb-3">
              Tipologia asporto
            </h3>
            <v-card class="mb-3 elevation-4 grey darken-4">
              <v-card-text>
                <v-radio-group v-model="currentMenu.takeAwayOptions">
                  <v-radio label="Ritiro al Negozio" value="shop"></v-radio>
                  <v-radio label="Consegna a Casa" value="home"></v-radio>
                  <v-radio label="Ritiro al Negozio e consegna a casa" value="home&amp;shop"></v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
            <v-layout column v-if="!currentUser.settings.googleMatrixDeliveryCostPerDistanceIsActive">
              <h3 class="headline mb-3" v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'">
                Costo consegna
              </h3>
              <v-layout wrap>
                <v-text-field
                  v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'"
                  v-model="currentMenu.deliveryPriceModifiers.chargeFee"
                  class="mr-3"
                  label="Costo della consegna"
                  :prepend-icon="currentMenu.deliveryPriceModifiers.chargeType != 'percent' ? 'euro_symbol' : 'fa-percent'"
                ></v-text-field>
                <v-radio-group
                  v-model="currentMenu.deliveryPriceModifiers.chargeType"
                  v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'"
                >
                  <v-radio label="Costo di consegna fisso" value="fixed"></v-radio>
                  <v-radio label="Costo di consegna in percentuale" value="percent"></v-radio>
                </v-radio-group>
              </v-layout>
              <h3 class="headline mb-3" v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'">
                Soglie ordine
              </h3>
              <v-layout wrap class="mb-3">
                <v-text-field
                  v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'"
                  v-model="currentMenu.deliveryPriceModifiers.freeDeliveryThreshold"
                  prepend-icon="euro_symbol"
                  label="Valore minimo per la consegna gratuita"
                ></v-text-field>
                <v-text-field
                  v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'"
                  v-model="currentMenu.deliveryPriceModifiers.minimumDeliverableOrder"
                  prepend-icon="euro_symbol"
                  label="Ordine minimo consegnabile"
                ></v-text-field>
              </v-layout>
            </v-layout>

            <v-layout
              column
              class="mb-3"
              v-if="
                currentUser.settings.googleMatrixDeliveryCostPerDistanceIsActive &&
                  (currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop')
              "
            >
              <h3 class="headline mb-3">
                Logica di calcolo del costo consegna
              </h3>
              <v-card class="mb-3 elevation-4 grey darken-4" v-for="(deliveryCostLogic, index) in currentMenu.googleMatrixDeliveryCostPerDistance" :key="index">
                <v-card-text>
                  <v-layout column>
                    <v-flex>
                      <v-switch :label="`Attiva soglia distanza`" v-model="deliveryCostLogic.isActive" :disabled="index == 0"></v-switch>
                    </v-flex>
                    <v-layout class="mb5" v-if="deliveryCostLogic.isActive">
                      <v-flex>
                        <v-slider
                          label="A partire dal KM"
                          hint="Distanza minima per scatenare la logica di calcolo prezzo"
                          persistent-hint
                          v-model="deliveryCostLogic.distanceThreshold"
                          :max="99"
                          :min="0"
                          :disabled="index == 0"
                        ></v-slider>
                      </v-flex>
                      <v-flex shrink style="width: 60px" class="ml-3">
                        <v-text-field
                          class="mt-0 noTopPadding"
                          hide-details
                          v-model="deliveryCostLogic.distanceThreshold"
                          type="number"
                          single-line
                          :max="99"
                          :min="0"
                          :disabled="index == 0"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-flex class="mt-3" v-if="deliveryCostLogic.isActive">
                      <v-layout class="mb-3 ">
                        <v-text-field
                          class="mb-2 mr-3"
                          v-model="deliveryCostLogic.cost"
                          :prepend-icon="switchIcon(deliveryCostLogic.type)"
                          label="Modificatore di Costo Consegna"
                        ></v-text-field>
                        <v-radio-group class="noTopPadding" v-model="deliveryCostLogic.type">
                          <v-radio
                            label="Moltiplica per Distanza"
                            persistent-hint
                            :hint="'Modificatore di Costo Consegna è moltiplicato per la distanza'"
                            value="distance"
                          ></v-radio>
                          <v-radio label="Percentuale" persistent-hint :hint="'Modificatore di Costo Consegna è un percentuale'" value="percentage"></v-radio>
                          <v-radio label="Fisso" persistent-hint :hint="'Modificatore di Costo Consegna è un valore fisso'" value="fixed"></v-radio>
                        </v-radio-group>
                      </v-layout>
                      <v-layout>
                        <v-text-field
                          v-model="deliveryCostLogic.minimumOrderThreshold"
                          prepend-icon="euro_symbol"
                          label="Ordine minimo consegnabile"
                          class="mr-3"
                        ></v-text-field>
                        <v-text-field
                          v-model="deliveryCostLogic.minCostThresholdForCustomCost"
                          prepend-icon="euro_symbol"
                          label="Valore minimo per la consegna customizzata"
                          class="mr-3"
                        ></v-text-field>
                        <v-text-field v-model="deliveryCostLogic.customCost" prepend-icon="euro_symbol" label="Valore consegna customizzata"></v-text-field>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-layout>

            <v-layout
              column
              v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop' || currentMenu.takeAwayOptions == 'shop'"
            >
              <h3 class="headline mb-3">
                Sconti applicabili
              </h3>
              <v-card class="elevation-4 grey darken-4">
                <v-card-text>
                  <v-layout wrap v-if="currentMenu.takeAwayOptions == 'home' || currentMenu.takeAwayOptions == 'home&shop'">
                    <v-text-field
                      v-model="currentMenu.menuDiscount.homeValue"
                      class="mr-3"
                      label="Valore sconto applicato alla consegna a domicilio"
                      :prepend-icon="currentMenu.menuDiscount.homeIsPercentage ? 'fa-percent' : 'euro_symbol'"
                    ></v-text-field>

                    <v-radio-group v-model="currentMenu.menuDiscount.homeIsPercentage">
                      <v-radio label="Sconto fisso" v-bind:value="false"></v-radio>
                      <v-radio label="Sconto in percentuale" v-bind:value="true"></v-radio>
                    </v-radio-group>
                  </v-layout>
                  <v-layout wrap v-if="currentMenu.takeAwayOptions == 'shop' || currentMenu.takeAwayOptions == 'home&shop'">
                    <v-text-field
                      v-model="currentMenu.menuDiscount.shopValue"
                      class="mr-3"
                      label="Valore sconto applicato per il ritiro al locale"
                      :prepend-icon="currentMenu.menuDiscount.shopIsPercentage ? 'fa-percent' : 'euro_symbol'"
                    ></v-text-field>

                    <v-radio-group v-model="currentMenu.menuDiscount.shopIsPercentage">
                      <v-radio label="Sconto fisso" v-bind:value="false"></v-radio>
                      <v-radio label="Sconto in percentuale" v-bind:value="true"></v-radio>
                    </v-radio-group>
                  </v-layout>
                  <h3 v-if="Number(currentMenu.menuDiscount.shopValue) > 0 || Number(currentMenu.menuDiscount.homeValue) > 0">
                    Condizioni particolari
                  </h3>
                  <v-switch
                    v-if="Number(currentMenu.menuDiscount.shopValue) > 0 || Number(currentMenu.menuDiscount.homeValue) > 0"
                    persistent-hint
                    :hint="'Con questa opzione, lo sconto sarà applicato solo nel primo ordine eseguito dopo la registrazione utente'"
                    primary
                    label="Applica solo in fase di registrazione"
                    v-model="currentMenu.menuDiscount.onlyOnRegistration"
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-layout>
          </v-layout>
          <h3 class="headline mb-3">Quando usare questo menu</h3>
          <v-card class="elevation-4 grey darken-4">
            <v-card-title>
              <h3 class="headline mb-0">Regole di validità</h3>
              <v-menu bottom right>
                <v-btn icon slot="activator" dark>
                  <v-icon>add</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click.native="addRole(1)">
                    <v-list-tile-title>Periodo</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-show="!rolePresent('G')" @click.native="addRole(2)">
                    <v-list-tile-title>Giorni</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click.native="addRole(3)">
                    <v-list-tile-title>Fascia Oraria</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-show="!rolePresent('S')" @click.native="addRole(4)">
                    <v-list-tile-title>Sempre</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-show="!rolePresent('M')" @click.native="addRole(5)">
                    <v-list-tile-title>Mai</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-show="keepSync && !rolePresent('A')" @click.native="addRole(6)">
                    <v-list-tile-title>Articolo presente</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-card-text>
              <v-layout column v-for="(role, index) in currentMenu.vRoles" :key="index">
                <v-flex row v-if="role.type == 'S' || role.type == 'M'">
                  <h4 class="green--text">{{ getRoleName(role) }}</h4>
                </v-flex>
                <v-flex row v-if="role.type == 'P' || role.type == 'G' || role.type == 'O'">
                  {{ getRoleName(role) }}
                  <v-btn @click.native="delRole(index)" fab dark small class="red">
                    <v-icon dark>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex style="display: flex" v-if="role.type == 'P'">
                  <v-flex xs12 lg6>
                    <v-text-field
                      @click.native.stop="openPicker(role.content, index, 'dateStart', 'dateStartFormatted')"
                      label="Data Inizio"
                      :value="formatDate(role.content.dateStart)"
                      append-icon="cancel"
                      :append-icon-cb="ev => clearDate(ev, role.content, index, 'dateStart', 'dateStartFormatted')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <v-text-field
                      @click.native.stop="openPicker(role.content, index, 'dateStop', 'dateStopFormatted')"
                      label="Data Fine"
                      :value="formatDate(role.content.dateStop)"
                      append-icon="cancel"
                      :append-icon-cb="ev => clearDate(ev, role.content, index, 'dateStop', 'dateStopFormatted')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex v-if="role.type == 'G'">
                  <v-select :items="days" v-model="role.content" multiple chips hint="Seleziona i giorni in cui il menù è valido" persistent-hint></v-select>
                </v-flex>
                <v-flex style="display: flex" v-if="role.type == 'O'">
                  <v-flex xs12 lg6>
                    <v-text-field
                      @click.native.stop="openPicker(role.content, index, 'timeStart', 'timeStartFormatted', true)"
                      label="Orario Inizio"
                      :value="formatTime(role.content.timeStart)"
                      append-icon="cancel"
                      :append-icon-cb="ev => clearDate(ev, role.content, index, 'timeStart', 'timeStartFormatted')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <v-text-field
                      @click.native.stop="openPicker(role.content, index, 'timeStop', 'timeStopFormatted', true)"
                      label="Orario Fine"
                      :value="formatTime(role.content.timeStop)"
                      append-icon="cancel"
                      :append-icon-cb="ev => clearDate(ev, role.content, index, 'timeStop', 'timeStopFormatted')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex style="display: flex" v-if="role.type == 'A'">
                  <v-flex xs12 lg6>
                    <v-text-field label="Codice gruppo" append-icon="cancel" v-model="role.content"></v-text-field>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
      <v-dialog v-model="pickerOpenTime" lazy full-width>
        <v-time-picker
          v-if="pickerOpenTime"
          ref="timeTimePickerRef"
          dark
          v-model="pickerTimeModel"
          scrollable
          format="24hr"
          actions
          locale="it"
          @input="checkMinutesTime"
          :allowed-minutes="allowedTimes"
        ></v-time-picker>
      </v-dialog>
      <v-dialog v-model="pickerOpen" lazy full-width>
        <v-tabs :value="pickerTab" grow icons>
          <v-tab href="#calendar">
            <v-icon>event</v-icon>
          </v-tab>
          <v-tab-item id="calendar">
            <v-date-picker
              v-if="pickerOpen"
              dark
              v-model="pickerDateModel"
              scrollable
              @input="toTime"
              actions
              locale="it"
              first-day-of-week="1"
            ></v-date-picker>
          </v-tab-item>

          <v-tab href="#timer">
            <v-icon>access_time</v-icon>
          </v-tab>
          <v-tab-item id="timer">
            <v-time-picker
              v-if="pickerOpen"
              ref="timePickerRef"
              dark
              v-model="pickerTimeModel"
              scrollable
              format="24hr"
              @input="checkMinutes"
              actions
              locale="it"
              first-day-of-week="1"
              :allowed-minutes="allowedTimes"
            ></v-time-picker>
          </v-tab-item>
        </v-tabs>
      </v-dialog>
      <v-btn fixed dark fab bottom right :disabled="cannotSave()" @click.native="save" class="orange floatingBtn">
        <v-icon>save</v-icon>
      </v-btn>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
/**
 * Modifica un menu
 * @module components/common/MenuEditor
 */
import api from '@/api'
export default {
  name: 'menuEditor',
  data() {
    return {
      currentMenu: {},
      days: [
        { text: 'Lunedi', value: 1 },
        { text: 'Martedi', value: 2 },
        { text: 'Mercoledi', value: 3 },
        { text: 'Giovedi', value: 4 },
        { text: 'Venerdi', value: 5 },
        { text: 'Sabato', value: 6 },
        { text: 'Domenica', value: 7 }
      ],
      currentLang: 'IT',
      title: '',
      pickerOpen: false,
      pickerOpenTime: false,
      pickerValue: null,
      pickerFormattedValue: null,
      pickerDateModel: null,
      pickerTimeModel: null,
      pickerIndex: null,
      pickerLimit: null,
      pickerLimitF: null,
      pickerTab: 'calendar',
      pickerDate: null,
      typeOrder: ['G', 'P', 'O', 'S', 'M', 'A'],
      classModeEnabled: false,
      currentUser: {}
    }
  },
  beforeMount() {
    this.currentUser = this.$store.getters.User
    this.classModeEnabled = this.currentUser.classModeEnabled

    if (this.$route.params.hasOwnProperty('menu')) {
      this.currentMenu = this.$route.params.menu
      // fix missing properties
      if (!this.currentMenu.hasOwnProperty('_id')) {
        this.title = 'Nuovo Menu'
      } else {
        this.title = 'Modifica Menu'
        if (this.currentMenu.isTakeAway && this.currentMenu.itsClassMenu && this.classModeEnabled) {
          this.currentMenu.isTakeAway = false
        }
      }
      // apply the default isBrowseable property
      if (!this.currentMenu.hasOwnProperty('isBrowseable')) {
        this.currentMenu.isBrowseable = true
      }

      // apply the default isActive property
      if (!this.currentMenu.hasOwnProperty('isActive')) {
        this.currentMenu.isActive = true
      }

      // sort intervals here
      if (this.currentUser.settings.googleMatrixDeliveryCostPerDistanceIsActive) {
        this.currentMenu.googleMatrixDeliveryCostPerDistance.sort((a, b) => {
          if (a.isActive && b.isActive) return numeral(a.distanceThreshold).value() - numeral(b.distanceThreshold).value()
          else if (a.isActive) return -1
          else return 1
        })
      }


    } else {
      this.$router.back()
    }

    this.$store.dispatch('TOOLBAR_ACTIONS', [
      {
        icon: 'arrow_back',
        text: 'Indietro',
        callback: () => {
          this.$router.back()
        }
      }
    ])
  },
  methods: {
    save() {
      this.currentMenu.menuDiscount.homeValue = this.parse(this.currentMenu.menuDiscount.homeValue, false)
      this.currentMenu.menuDiscount.shopValue = this.parse(this.currentMenu.menuDiscount.shopValue, false)
      this.currentMenu.deliveryPriceModifiers.chargeFee = this.parse(this.currentMenu.deliveryPriceModifiers.chargeFee, false)
      this.currentMenu.deliveryPriceModifiers.freeDeliveryThreshold = this.parse(this.currentMenu.deliveryPriceModifiers.freeDeliveryThreshold, true)
      this.currentMenu.deliveryPriceModifiers.minimumDeliverableOrder = this.parse(this.currentMenu.deliveryPriceModifiers.minimumDeliverableOrder, false)

      this.currentMenu.googleMatrixDeliveryCostPerDistance.forEach(element => {
        element.distanceThreshold = this.parse(element.distanceThreshold, false)
        element.cost = this.parse(element.cost, false)
        element.minCostThresholdForCustomCost = this.parse(element.minCostThresholdForCustomCost, true)
        element.customCost = this.parse(element.customCost, false)
        element.minimumOrderThreshold = this.parse(element.minimumOrderThreshold, true)
      })

      this.$store.dispatch('UPDATEMENU', {
        menu: this.currentMenu,
        callback: () => this.$router.back()
      })
    },
    cannotSave() {
      return (
        utils.getMainDesc(this.currentMenu).length == '' ||
        this.currentMenu.vRoles.length == 0 ||
        !this.currentMenu.vRoles.every(role => {
          if (role.type == 'O') return role.content.timeStart != null && role.content.timeStop != null
          if (role.type == 'P') return role.content.dateStart != null && role.content.dateStop != null
          if (role.type == 'G') return role.content.length > 0
          return true
        })
      )
    },
    changeLang(lang) {
      this.currentLang = lang
    },
    setDescr(descr) {
      this.currentMenu.descrizione = descr
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    },
    formatTime(time) {
      return time ? moment(time, 'HH:mm:ss').format('HH:mm') : ''
    },
    clearDate(ev, content, index, limit, limitF) {
      ev.stopPropagation()
      this.currentMenu.vRoles[index].content[limit] = null
      this.currentMenu.vRoles[index].content[limitF] = null
    },
    addRole(type) {
      switch (type) {
        case 1:
          this.currentMenu.vRoles = this.currentMenu.vRoles
            .filter(r => r.type != 'S' && r.type != 'M')
            .concat([
              {
                type: 'P',
                index: this.currentMenu.vRoles.filter(r => r.type == 'P').length + 1,
                content: {
                  dateStart: null,
                  dateStop: null,
                  dateStartFormatted: null,
                  dateStopFormatted: null
                }
              }
            ])
          break
        case 2:
          this.currentMenu.vRoles = this.currentMenu.vRoles.filter(r => r.type != 'S' && r.type != 'M').concat([{ type: 'G', content: [1, 2, 3, 4, 5, 6, 7] }])
          break
        case 3:
          this.currentMenu.vRoles = this.currentMenu.vRoles
            .filter(r => r.type != 'S' && r.type != 'M')
            .concat([
              {
                type: 'O',
                index: this.currentMenu.vRoles.filter(r => r.type == 'O').length + 1,
                content: {
                  timeStart: null,
                  timeStop: null,
                  timeStartFormatted: null,
                  timeStopFormatted: null
                }
              }
            ])
          break
        case 4:
          this.currentMenu.vRoles = [{ type: 'S' }]
          break
        case 5:
          this.currentMenu.vRoles = [{ type: 'M' }]
          break
        case 6:
          this.currentMenu.vRoles = this.currentMenu.vRoles
            .filter(r => r.type != 'S' && r.type != 'M')
            .concat([
              {
                type: 'A',
                index: this.currentMenu.vRoles.filter(r => r.type == 'P').length + 1,
                content: ''
              }
            ])
          break
      }

      this.currentMenu.vRoles.sort((a, b) => {
        return (
          this.typeOrder.findIndex(o => o == a.type) > this.typeOrder.findIndex(o => o == b.type) &&
          (a.hasOwnProperty('index') && b.hasOwnProperty('index') ? a.index > b.index : true)
        )
      })
    },
    getRoleName(role) {
      switch (role.type) {
        case 'P':
          return `Periodo ${role.index}`
        case 'G':
          return `Giorni`
        case 'O':
          return `Fascia Oraria ${role.index}`
        case 'S':
          return `Sempre`
        case 'M':
          return `Mai`
        case 'A':
          return `Articolo presente`
      }
    },
    openPicker(content, index, limit, limitF, onlyTime = false) {
      if (onlyTime) {
        this.pickerOpenTime = true
        this.pickerValue = content[limit]
        this.pickerFormattedValue = null
        this.pickerIndex = index
        this.pickerLimit = limit
        this.pickerLimitF = limitF
        return
      }

      this.pickerOpen = true
      this.pickerFormattedValue = null
      this.pickerDateModel = content[limit] ? moment(content[limit]).format('YYYY-MM-DD') : null
      this.pickerTimeModel = content[limit] ? moment(content[limit]).format('HH:mm:ss') : null
      this.pickerValue = content[limit]
      this.pickerIndex = index
      this.pickerLimit = limit
      this.pickerLimitF = limitF
      this.pickerTab = 'calendar'
    },
    rolePresent(type) {
      return typeof this.currentMenu.vRoles !== 'undefined' ? this.currentMenu.vRoles.filter(r => r.type == type).length != 0 : false
    },
    toTime(input) {
      this.pickerTab = 'timer'
      this.pickerDateModel = input
    },
    checkMinutes(val) {
      if (this.$refs.timePickerRef.selectingHour === false) {
        this.pickerValue = this.pickerDateModel + 'T' + this.pickerTimeModel + ':00'
        this.pickerFormattedValue = this.pickerDateModel + ' ' + this.pickerTimeModel + ':00'
        this.pickerOpen = false
      }
    },
    checkMinutesTime(val) {
      if (this.$refs.timeTimePickerRef.selectingHour === false) {
        this.pickerValue = this.pickerTimeModel + ':00'
        this.pickerFormattedValue = this.pickerTimeModel + ':00'
        this.pickerOpenTime = false
      }
    },
    allowedTimes(value) {
      return value % 5 == 0
    },
    delRole(index) {
      this.currentMenu.vRoles.splice(index, 1)
      if (this.currentMenu.vRoles.length == 0) {
        this.addRole(4)
      }
    },
    checkTakeAwayValue(value) {
      if (this.currentMenu.isTakeAway == true) {
        this.currentMenu.isTakeAway = false
      }
    },
    checkClassValue(value) {
      if (this.currentMenu.itsClassMenu == true) {
        this.currentMenu.itsClassMenu = false
      }
      if (value == false) {
        this.currentMenu.takeAwayOptions = 'shop'
      }
    },
    parse(value, isFreeDeliveryThreshold) {
      let parsed = value != null ? value.toString().replaceAll(',', '.') : null
      let isNumber = parsed ? parseFloat(parsed) : null

      if ((isNumber == null || isNaN(isNumber)) && !isFreeDeliveryThreshold) {
        parsed = '0'
      }

      return parsed
    },
    sortByDistance(definitions) {
      return definitions.sort((a, b) => {
        const da = a.active ? a.distanceThreshold || 0 : -1
        const db = b.active ? b.distanceThreshold || 0 : -1
        return da - db
      })
    },
    switchIcon(type) {
      let icon

      switch (type) {
        case 'distance': {
          icon = 'euro_symbol'
          break
        }
        case 'percentage': {
          icon = 'fa-percent'
          break
        }
        case 'fixed': {
          icon = 'euro_symbol'
          break
        }
      }
      return icon
    }
  },
  watch: {
    pickerOpen(newV, oldV) {
      if (!newV && oldV) {
        this.currentMenu.vRoles[this.pickerIndex].content[this.pickerLimit] = this.pickerValue
        this.currentMenu.vRoles[this.pickerIndex].content[this.pickerLimitF] = this.pickerFormattedValue
        this.pickerFormattedValue = null
        this.pickerDateModel = null
        this.pickerTimeModel = null
        this.pickerValue = null
        this.pickerIndex = null
        this.pickerLimit = null
        this.pickerLimitF = null
        this.pickerTab = 'calendar'
      }
    },
    pickerOpenTime(newV, oldV) {
      if (!newV && oldV) {
        this.currentMenu.vRoles[this.pickerIndex].content[this.pickerLimit] = this.pickerValue
        this.currentMenu.vRoles[this.pickerIndex].content[this.pickerLimitF] = this.pickerFormattedValue
        this.pickerFormattedValue = null
        this.pickerValue = null
        this.pickerIndex = null
        this.pickerLimit = null
        this.pickerLimitF = null
      }
    }
  },
  computed: {
    listini() {
      return this.$store.getters.Listino
    },
    editing() {
      return this.currentMenu.hasOwnProperty('_id')
    },
    keepSync() {
      return this.$store.getters.User.keepSync
    }
  }
}
</script>

<style lang="stylus" scoped>
.picker >>> .picker__title {
    order: 1;
}

.noTopPadding {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MenuEditor.vue